"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryResolver = void 0;
/**
 * Base class to resolve configuration queries.
 */
class QueryResolver {
    constructor() {
        this._isInitialized = false;
    }
    /**
     * Validates that the inputs are of expected configType.
     * If not an Error is thrown
     *
     * @param name Name of the specific configuration to query.
     * @param args Input parameters used to resolve the query.
     *
     * @throws Error Thrown if arguments are not of expected type
     */
    validate(name, args) {
        const targetConfigType = this.getTargetConfigType();
        if (name.getConfigType() !== targetConfigType || args.getConfigType() !== targetConfigType) {
            throw new Error(this.getValidationErrorMessage());
        }
    }
    /**
     * Gets the resolver's initialization state.
     *
     * @return true if sucessfully initialized, false otherwise.
     */
    isInitialized() {
        return this._isInitialized;
    }
    setInitializedState(isInitialized) {
        this._isInitialized = isInitialized;
    }
}
exports.QueryResolver = QueryResolver;
//# sourceMappingURL=query-resolver.js.map